"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckRailReefer = function SvgIconTruckRailReefer(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck rail reefer icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Rail Reefer Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.18 29V4h40v25h-40zm4-4h2V8h-2v17zm20.91-7.5h4.09c.55 0 1-.45.98-1.02 0-.55-.45-1-1-1h-4.09l2.79-2.79a.996.996 0 10-1.41-1.41l-4.21 4.21h-1.09v-1.63l4.16-4.16a.996.996 0 10-1.41-1.41l-2.75 2.75V8c0-.55-.45-1-1-1s-1 .45-1 1v3.13l-2.84-2.84a.996.996 0 00-1.41 0c-.19.2-.29.45-.29.71 0 .26.09.51.29.71l4.25 4.25v1.56h-1.09l-4.21-4.21a.996.996 0 10-1.41 1.41l2.79 2.79h-4.09c-.55 0-1 .45-1 1s.45 1 1 1h4.09l-2.79 2.79a.996.996 0 000 1.41c.2.19.45.29.71.29.26 0 .51-.09.71-.29l4.21-4.21h1.09v1.54l-4.25 4.25c-.19.2-.29.45-.29.71a.996.996 0 001.7.71l2.84-2.84V25c0 .55.45 1 1 1s1-.45 1-1v-3.06l2.75 2.75a.996.996 0 101.41-1.41l-4.16-4.16v-1.63h1.09l4.21 4.21c.2.19.45.29.71.29a.996.996 0 00.71-1.7l-2.79-2.79zm9.09 7.5h2V8h-2v17zm6.32 9h-41c-.83 0-1.5-.67-1.5-1.5S2.67 31 3.5 31h41c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM8 44a4 4 0 004-4 4 4 0 108 0 4 4 0 00-8 0 4 4 0 10-4 4zm24 0a4 4 0 004-4 4 4 0 108 0 4 4 0 00-8 0 4 4 0 10-4 4z"
  }));
};

var _default = SvgIconTruckRailReefer;
exports.default = _default;